import Vue from "vue";
import VueRouter from "vue-router";
import Radingcenter from "@/views/financial/Radingcenter";
import Transaction from "@/views/financial/Transaction";

Vue.use(VueRouter);

export default [{
    path: "radingcenter", //交易中心
    name: "Radingcenter",
    component: Radingcenter
  },
  {
    path: "transaction/:applyNo", //交易明细
    name: "Transaction",
    component: Transaction
  }
]